<template>
    <div class="row product-row ScannedItem" :class="{'selected': selected}">
        <a @click.prevent="selectItem(position)">
            <div class="col-3 item-img text-center">
               <LazyImage :src="imgsrc" />
            </div>
            <div class="col-9 item-text">
                <div class="form-group">
                    <div class="form-label">
                        SKU
                    </div>
                    <div>
                        {{ sku }}
                    </div>
                </div>
                <div class="form-group" v-if='upc'>
                    <div class="form-label">
                        UPC
                    </div>
                    <div>
                        {{ upc }}
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        Description
                    </div>
                    <div>
                        {{ desc }}
                    </div>
                </div>
                <div class="form-group"  v-if='offer'>
                    <div class="form-label">
                        SO #
                    </div>
                    <div>
                        {{ ordernum }}
                    </div>
                </div>
                <div class="form-group"  v-if='offer'>
                    <div class="form-label">
                        PO #
                    </div>
                    <div>
                        {{ ponum }}
                    </div>
                </div>
                <div class="form-group"  v-if='offer'>
                    <div class="form-label">
                        Offer #
                    </div>
                    <div>
                        {{ offer }}
                    </div>
                </div>
                <div class="form-group"  v-if='offer'>
                    <div class="form-label">
                        STORE #
                    </div>
                    <div>
                        {{ storeno }}
                    </div>
                </div>
                <!-- <div class="form-group" v-if='bin'>
                    <div>
                        BIN: {{ bin }}
                    </div>
                </div> -->
            </div>
        </a>
    </div>
</template>
<script>
import LazyImage from './LazyImage';
export default {
    name: 'ScannedItem',
    components:{
        LazyImage,
    },
    props:['imgsrc', 'sku', 'upc', 'desc', 'position', 'picked', 'bin', 'storeno', 'offer', 'ponum', 'ordernum'],
    data(){
        return{
            skuTracker: this.sku
        }
    },
    computed:{
        selected(){
            return this.$props.picked
        },
        ItemImageClass(){
            return 'img-fluid ' + this.$props.sku
        }
    },
    methods:{
        selectItem(item){
            this.$emit('select-item', item);
        },
        
    }
}
</script>